export default {
  actions: {
    FETCH_ROOMS: 'fetchRooms',
  },
  mutations: {
    RECEIVE_ROOMS: 'receiveRooms',
    FETCHING_ROOMS: 'fetchingRooms',
  },
  getters: {
    GET_ROOMS: 'getRooms',
    GET_ROOM_BY_ID: 'getRoomById',
    GET_ROOM_BY_POSITION: 'getRoomByPosition',
    HAS_ROOMS: 'hasRooms',
    IS_FETCHING: 'isFetching',
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/room/types.js